import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { CiImageOn, CiSearch } from "react-icons/ci";
import { LiaSpinnerSolid } from "react-icons/lia";
import { MdDeleteOutline } from "react-icons/md";
import { FaRegSave, FaClipboardList, FaSpinner, FaFileDownload } from 'react-icons/fa';
import blueKbcLogo from '../../../assets/images/branding/blue-kbc-logo.png';
import ItemAddedToaster from '../../toasterscomponents/checklistToasters/ItemAddedToaster';
import FilledInChecklistToaster from '../../toasterscomponents/FilledInChecklistToaster';
import CreatedSuccesFullyToaster from '../../toasterscomponents/shepacktoasters/CreatedSuccesFullyToaster';
import { saveAs } from 'file-saver';
import { IoMdDownload } from 'react-icons/io';

const ToasterViewSubmissionComponent = ({ 
  isOpen, 
  onClose,
  selectedShePackName,
  shePackDocumentName,
  shePackDocuments,
  isLoading,
  questionsPerDocument,
  shePackDocumentScore,
  selectedUser,
  selectedCompany,
  selectedDepartment,
  selectedCompanyName,
  selectedDepartmentName
}) => {
  const navigate = useNavigate();
  const [expandedDocuments, setExpandedDocuments] = useState({});
  const [showToaster, setShowToaster] = useState({});
  const [showSuccess, setShowSuccess] = useState(false);
  const [comments, setComments] = useState({});
  const [questionScores, setQuestionScores] = useState({});
  const [fullScreenImage, setFullScreenImage] = useState(null);
  const [imageError, setImageError] = useState(null);

  const [totalUserScore, setTotalUserScore] = useState(0);
const [shePackScore, setShePackScore] = useState(0);
const [totalUserPercentage, setTotalUserPercentage] = useState(0);
  
  const user = JSON.parse(sessionStorage.getItem('user'));

  // Add this useEffect to calculate the total scores whenever shePackDocuments changes
  // Add this useEffect to calculate the total scores whenever shePackDocuments changes
useEffect(() => {
  if (shePackDocuments && shePackDocuments.length > 0) {
    let userScoreSum = 0;
    let totalMaxScore = 0;
    
    shePackDocuments.forEach(document => {
      // Check if this document is marked as "Not Applicable"
      const isDocumentNA = document.user_score === 0 && 
                          document.updated_she_pack_document_score === 0 && 
                          parseFloat(document.user_percentage) === 0;
      
      if (isDocumentNA) {
        // Skip this document - don't add to either total
      } else {
        // Add applicable document scores to totals
        userScoreSum += Number(document.user_score);
        totalMaxScore += Number(document.updated_she_pack_document_score);
      }
    });
    
    setTotalUserScore(userScoreSum);
    setShePackScore(totalMaxScore);
    
    // Calculate percentage only if we have applicable documents
    if (totalMaxScore > 0) {
      setTotalUserPercentage(((userScoreSum / totalMaxScore) * 100).toFixed(2));
    } else {
      setTotalUserPercentage(0);
    }
  }
}, [shePackDocuments]);
  
  

  useEffect(() => {
    const timers = Object.keys(showToaster).map(key => 
      showToaster[key] && setTimeout(() => setShowToaster(prev => ({ ...prev, [key]: false })), 3000)
    );
    return () => timers.forEach(timer => clearTimeout(timer));
  }, [showToaster]);

  // Toggle document expansion
  const toggleDocument = (documentId) => {
    setExpandedDocuments(prev => ({ ...prev, [documentId]: !prev[documentId] }));
  };

  // Function to convert buffer to base64
  const bufferToBase64 = (buffer) => {
    if (buffer && buffer.type === 'Buffer' && Array.isArray(buffer.data)) {
      const binaryString = buffer.data.map(byte => String.fromCharCode(byte)).join('');
      return btoa(binaryString);
    }
    return null;
  };

  // Function to open full screen image
  const openFullScreenImage = (question) => {

    try {
      if (!question || !question.user_file_response) {
        setImageError("No image available");
        return;
      }
      
      const fileResponse = question.user_file_response;
      const base64String = bufferToBase64(fileResponse);
      
      if (!base64String) {
        setImageError("Failed to process image");
        return;
      }

      const base64ToBinary = atob(base64String);
      const mimeType = 'image/png'; // Use document's mime type if available
      
      setFullScreenImage(`data:${mimeType};base64,${base64ToBinary}`);
      setImageError(null);
    } catch (error) {
      console.error("Error processing file:", error);
      setImageError("Error displaying image");
    }
  };

  // Function to close full screen image
  const closeFullScreenImage = () => {
    setFullScreenImage(null);
    setImageError(null);
  };

  // Function to download report
  const handleTemplateDownloadReport = async (document) => {
  // Get questions for this document
  const documentQuestions = questionsPerDocument[document.shepack_document_id];
  if (!documentQuestions) return;
  
  // Create an array to collect all images
  let allImages = [];
  
  // Process all images first and collect them
  Object.entries(documentQuestions).forEach(([category, categoryQuestions]) => {
    categoryQuestions.forEach((question, index) => {
      if (question.user_file_response) {
        try {
          const fileResponse = question.user_file_response;
          const base64String = bufferToBase64(fileResponse);
          
          if (base64String) {
            const base64ToBinary = atob(base64String);
            const mimeType = 'image/png'; // Use document's mime type if available
            
            // Store image info with reference to question
            allImages.push({
              imageContent: `
                <div>
                  <h4>Image for question: ${question.question_name}</h4>
                  <img src="data:${mimeType};base64,${base64ToBinary}" class="document-image" alt="User uploaded image" />
                </div>
              `,
              questionName: question.question_name,
              category: category
            });
          }
        } catch (error) {
          console.error("Error processing image for report:", error);
          allImages.push({
            imageContent: '<p><em>Image could not be included in report</em></p>',
            questionName: question.question_name,
            category: category
          });
        }
      }
    });
  });
  
  // Create HTML content for the document
  let htmlContent = `
    <!DOCTYPE html>
    <html>
    <head>
      <meta charset="utf-8">
      <title>${selectedShePackName} - ${document.shepack_document_name}</title>
      <style>
        body { font-family: Arial, sans-serif; margin: 3px; }
        h1 { color:rgb(0, 0, 0); }
        h2 { color:rgb(0, 0, 0); margin-top: 10px; }
        p {font-size: 11px}
        table { font-size: 11px; width: 100%; border-collapse: collapse; margin-bottom: 5px; }
        th { background-color: #f2f2f2; padding: 10px; text-align: left; border: 1px solid #ddd; max-width: 200px; }
        td { padding: 5px; border: 1px solid #ddd; max-width: 200px; overflow: hidden; word-wrap: break-word; }
        .meta-info { margin-bottom: 5px; }
        .document-image { max-width: 500px; max-height: 300px; margin-top: 5px; border: 1px solid #ddd; }
      </style>
    </head>
    <body>
      <h2>Legal Compliance - View Template Submission</h2>

      <p>The Legal Compliance Audit conducted utilises the following Legislation ${document.shepack_document_name} to determine where ${selectedCompanyName} is adhering to the minimum standards. </p>
      
      <div class="meta-info">
        <table class="meta-info">
          <tr>
            <th>SHE File Name:</th>
            <td>${selectedShePackName}</td>
          </tr>
          <tr>
            <th>Template Name:</th>
            <td>${document.shepack_document_name}</td>
          </tr>
          <tr>
            <th>Company:</th>
            <td>${selectedCompanyName}</td>
          </tr>
          <tr>
            <th>Site:</th>
            <td>${selectedDepartmentName}</td>
          </tr>
          <tr>
            <th>Submitted By:</th>
            <td>${user.userName} ${user.userSurname}</td>
          </tr>
          <tr>
            <th>Document Score:</th>
            <td>
              ${document.user_score === 0 && document.updated_she_pack_document_score === 0 && 
                (parseFloat(document.user_percentage) === 0)
                    ? 'Not Applicable'
                      : `${document.user_score} / ${document.updated_she_pack_document_score}`
                } 
            </td>
          </tr>
          <tr>
            <th>Percentage:</th>
            <td>
                ${document.user_score === 0 && document.updated_she_pack_document_score === 0 && 
                (parseFloat(document.user_percentage) === 0)
                    ? 'Not Applicable'
                      : `${document.user_percentage} %`
                } 
            </td>
          </tr>
          <tr>
            <th>Status:</th>
            <td>${document.submission_status || 'No submission'}</td>
          </tr>
        </table>

      </div>

      <div>
        <h2>Outcome of Legal Compliance</h2>
      </div>
  `;
  
  // For each category, add questions to the document (WITHOUT images)
  Object.entries(documentQuestions).forEach(([category, categoryQuestions]) => {
    // Add category title
    htmlContent += `
      <h2>${category === ''
          ? '' : `Category - ${category}`}</h2>
      <table>
        <thead>
          <tr>
            <th>Question </th>
            <th>Reference</th>
            <th>Score</th>
            <th>Percentage</th>
            <th>Additional Info</th>
          </tr>
        </thead>
        <tbody>
    `;
    
    // Add question rows
    categoryQuestions.forEach(question => {
      htmlContent += `
        <tr>
          <td>${question.question_name}</td>
          <td>${question.question_reference}</td>
          <td>
            ${question.user_question_score === 'Not Applicable'
              ? 'Not Applicable'
              : `${question.user_question_score || 'Score Not Selected'} / ${question.question_score}`
            }
          </td>

          <td>
          ${question.user_question_score === 'Not Applicable'
            ? 'Not Applicable'
            : question.user_question_score && question.question_score
              ? ((question.user_question_score / question.question_score) * 100).toFixed(2) + ' %'
              : 'N/A'}
        </td>


          <td>
            ${question.user_comment || 'No additional comments provided.'}
          </td>
        </tr>
      `;
    });
    
    htmlContent += `
        </tbody>
      </table>
    `;
  });
  
  // Add Annexure section with all images if there are any
  if (allImages.length > 0) {
    htmlContent += `
      <h2>Annexure</h2>
      <p>The following images were submitted as part of the audit:</p>
    `;
    
    // Group images by category
    const imagesByCategory = {};
    allImages.forEach(image => {
      if (!imagesByCategory[image.category]) {
        imagesByCategory[image.category] = [];
      }
      imagesByCategory[image.category].push(image);
    });
    
    // Add images organized by category
    Object.entries(imagesByCategory).forEach(([category, images]) => {
      htmlContent += `
        <h3>${category}</h3>
      `;
      
      images.forEach(image => {
        htmlContent += image.imageContent;
      });
    });
  }
  
  // Close the HTML document
  htmlContent += `
    </body>
    </html>
  `;
  
  // Create a Blob with the HTML content
  const blob = new Blob([htmlContent], { type: 'application/vnd.ms-word;charset=utf-8' });
  
  // Use saveAs to download the file
  saveAs(blob, `${selectedShePackName}_${document.shepack_document_name}_Report.doc`);
};

//


const handleSheFileDownloadReport = async () => {
  // Exit if no documents
  if (!shePackDocuments || shePackDocuments.length === 0) return;
  
  // Calculate if all documents are "Not Applicable"
  let allDocumentsNA = true;
  let totalUserScore = 0;
  let totalMaxScore = 0;
  
  shePackDocuments.forEach(document => {
    // Check if this document is applicable
    const isDocumentNA = document.user_score === 0 && 
                         document.updated_she_pack_document_score === 0 && 
                         parseFloat(document.user_percentage) === 0;
    
    // If any document is applicable, set allDocumentsNA to false
    if (!isDocumentNA) {
      allDocumentsNA = false;
      // Add to total scores for applicable documents
      totalUserScore += Number(document.user_score);
      totalMaxScore += Number(document.updated_she_pack_document_score);
    }
  });
  
  // Calculate total percentage
  const totalPercentage = totalMaxScore > 0 ? ((totalUserScore / totalMaxScore) * 100).toFixed(2) : 0;
  
  // Create HTML content for the consolidated report
  let htmlContent = `
    <!DOCTYPE html>
    <html>
    <head>
      <meta charset="utf-8">
      <title>${selectedShePackName} - Consolidated Report</title>
      <style>
        body { font-size: 10pt; font-family: 'Calibri', sans-serif; margin: 3px; line-height: 0.8cm; }
        h1 { color:rgb(0, 0, 0); }
        h2 { color:rgb(0, 0, 0); margin-top: 10px; }
        h3 { color:rgb(0, 0, 0); margin-top: 10px; }
       
        table { width: 100%; border-collapse: collapse; margin-bottom: 5px; }
        th { background-color: #f2f2f2; padding: 10px; text-align: left; border: 1px solid #ddd; max-width: 100px; }
        td { padding: 5px; border: 1px solid #ddd; max-width: 200px; overflow: hidden; word-wrap: break-word; }
        .meta-info { margin-bottom: 5px; }
       
      </style>
    </head>
    <body>
      <h2>LEGAL COMPLIANCE AUDIT REPORT</h2>

      <p>The Legal Compliance Audit was conducted for ${selectedShePackName} she file to determine if ${selectedCompanyName} is adhering to the minimum standards.</p>
      
      <div class="meta-info">
        <table class="meta-info">
          <tr>
            <th>SHE File Name:</th>
            <td>${selectedShePackName}</td>
          </tr>
          <tr>
            <th>Company:</th>
            <td>${selectedCompanyName}</td>
          </tr>
          <tr>
            <th>Site:</th>
            <td>${selectedDepartmentName}</td>
          </tr>
          <tr>
            <th>Submitted By:</th>
            <td>${user.userName} ${user.userSurname}</td>
          </tr>
        </table>
      </div>

      <div>
        <h3>CONSOLIDATED OUTCOME: ${selectedShePackName} LEGAL COMPLIANCE AUDIT </h3>
      </div>
      
      <table>
        <thead>
          <tr>
            <th>Legislation</th>
            <th>Score</th>
            <th>Percentage</th>
          </tr>
        </thead>
        <tbody>
  `;
  
  // Add each document to the overview table
  shePackDocuments.forEach(document => {
    htmlContent += `
      <tr>
        <td>${document.shepack_document_name}</td>
        <td>
          ${document.user_score === 0 && document.updated_she_pack_document_score === 0 && parseFloat(document.user_percentage) === 0 && document.submission_status !== 'Not Started'
            ? 'Not Applicable'
            : `${document.user_score} / ${document.updated_she_pack_document_score}`
          }
        </td>
        <td>
          ${document.user_score === 0 && document.updated_she_pack_document_score === 0 && parseFloat(document.user_percentage) === 0 && document.submission_status !== 'Not Started'
            ? 'Not Applicable'
            : `${document.user_percentage}%`}
        </td>
      </tr>
    `;
  });

  // Add the total row with conditional display
  htmlContent += `
      <tr>
        <td><strong>Section Total</strong></td>
        <td>
          <strong>
            ${allDocumentsNA 
              ? 'Not Applicable' 
              : `${totalUserScore} / ${totalMaxScore}`
            }
          </strong>
        </td>
        <td>
            <strong>
            ${allDocumentsNA 
              ? 'Not Applicable' 
              : `${totalPercentage}%`
            }
            </strong>
          
        </td>
      </tr>
    </tbody>
  </table>
  `;
  
  // Now append detailed reports for each document
  shePackDocuments.forEach(document => {
    const documentQuestions = questionsPerDocument[document.shepack_document_id];
    if (!documentQuestions) return;
    
    // Add document section header
    htmlContent += `
      <h3>Detailed Template Report: ${document.shepack_document_name}</h3>

      <div class="meta-info">
        <table class="meta-info">
          <tr>
            <th>Document Name:</th>
            <td>${document.shepack_document_name}</td>
          </tr>
          <tr>
            <th>Section Score:</th>
            <td>
              ${document.user_score === 0 && document.updated_she_pack_document_score === 0 && parseFloat(document.user_percentage) === 0 && document.submission_status !== 'Not Started'
                ? 'Not Applicable'
                : `${document.user_score} / ${document.updated_she_pack_document_score}`}
            </td>
          </tr>
          <tr>
            <th>Section Percentage:</th>
            <td>
              ${document.user_score === 0 && document.updated_she_pack_document_score === 0 && parseFloat(document.user_percentage) === 0 && document.submission_status !== 'Not Started'
                ? 'Not Applicable'
                : `${document.user_percentage}%`}
            </td>
          </tr>
          
        </table>
      </div>
    `;
    
    // Process each category of questions
    Object.entries(documentQuestions).forEach(([category, categoryQuestions]) => {
      htmlContent += `
        <h3> ${category === ''
          ? '' : `Category - ${category}`}
        </h3>
        <table>
          <thead>
            <tr>
              <th>${document.shepack_document_name}</th>
              <th>Reference</th>
              <th>Auditor Remarks</th>
              <th>Score</th>
              <th>Percentage</th>
              
            </tr>
          </thead>
          <tbody>
      `;
      
      // Add question rows
      categoryQuestions.forEach(question => {
        htmlContent += `
          <tr>

            <td>${question.question_name}</td>

            <td>${question.question_reference || 'N/A'}</td>

            <td>
              ${question.user_comment || ''}
            </td>

            <td>
              ${question.user_question_score === 'Not Applicable'
                ? 'Not Applicable'
                : `${question.user_question_score || 'Score Not Selected'} / ${question.question_score}`
              }
            </td>
            <td>
              ${question.user_question_score === 'Not Applicable'
                ? 'Not Applicable'
                : question.user_question_score && question.question_score
                  ? ((question.user_question_score / question.question_score) * 100).toFixed(2) + ' %'
                  : 0 }
            </td>
            
          </tr>
          
        `;
      });
      
      htmlContent += `
          </tbody>
        </table>
      `;
    });
    
    // Add images for this document
    const allImages = [];
    
    // Process all images for the document
    Object.entries(documentQuestions).forEach(([category, categoryQuestions]) => {
      categoryQuestions.forEach(question => {
        if (question.user_file_response) {
          try {
            const fileResponse = question.user_file_response;
            const base64String = bufferToBase64(fileResponse);
            
            if (base64String) {
              const base64ToBinary = atob(base64String);
              const mimeType = 'image/png'; // Use document's mime type if available
              
              // Store image info with reference to question
              allImages.push({
                imageContent: `
                  <div class='image-container'>
                    <h4>Image for question: ${question.question_name}</h4>
                    <img src="data:${mimeType};base64,${base64ToBinary}"width="250" 
                      height="200"  class="document-image" alt="User uploaded image" />
                  </div>
                `,
                questionName: question.question_name,
                category: category
              });
            }
          } catch (error) {
            console.error("Error processing image for report:", error);
            allImages.push({
              imageContent: '<p><em>Image could not be included in report</em></p>',
              questionName: question.question_name,
              category: category
            });
          }
        }
      });
    });
    
    // Add Annexure section with all images if there are any
    if (allImages.length > 0) {
      htmlContent += `
        <h3>Annexure - ${document.shepack_document_name}</h3>
        <p>The following images were submitted as part of the audit:</p>
      `;
      
      // Group images by category
      const imagesByCategory = {};
      allImages.forEach(image => {
        if (!imagesByCategory[image.category]) {
          imagesByCategory[image.category] = [];
        }
        imagesByCategory[image.category].push(image);
      });
      
      // Add images organized by category
      Object.entries(imagesByCategory).forEach(([category, images]) => {
        htmlContent += `
          <h4>${category}</h4>
        `;
        
        images.forEach(image => {
          htmlContent += image.imageContent;
        });
      });
    }
  });
  
  // Close the HTML document
  htmlContent += `
    </body>
    </html>
  `;
  
  // Create a Blob with the HTML content
  const blob = new Blob([htmlContent], { type: 'application/vnd.ms-word;charset=utf-8' });
  
  // Use saveAs to download the file
  saveAs(blob, `${selectedShePackName}_Consolidated_Report.doc`);
};

  if (!isOpen) return null;

  return (
    <div className="checklist-question-user-fill-in-checklist-main-container">
      <div className="template-question-fill-in-checklist-container">
        <div className="template-fill-in-elements-container">
          <div className="consultant-fill-in-template-main-container">
            <div className='user-fill-in-back-button-container'>
              <img src={blueKbcLogo} alt="white-kbc-logo" className="add-quesiton-side-menu-logo" />
              <button type="button" onClick={onClose} className="user-fill-in-back-button">Back</button>
            </div>
          </div>
          
          <div className="consultant-Template-fill-in-header-main-container">
            <div className="Template-fill-in-header-text-and-search-main-container">
              <div className="Template-fill-in-header-text-main-container">
                <div>
                  <h2>Legal Compliance - <span className="secondary-color-paragraph">View Template Submissions</span></h2>
                  <p>You are viewing submissions for <span className='secondary-color-text'>{selectedCompanyName}</span> for the following site <span className='secondary-color-text'>{selectedDepartmentName}</span></p>
                  <p>Submitted By : {user.userName} {user.userSurname} for <span className='secondary-color-text'>{selectedShePackName}</span> she pack.</p>
                </div>

                <div >

                  <button 
                    className='download-ms-report-button'
                    disabled={isLoading || shePackDocuments.length === 0}
                    onClick={handleSheFileDownloadReport}
                  >
                    <FaFileDownload/>
                    Download She File Report
                  </button>

                  

                </div>
              </div>

              <div>
                <div className='consultant-fill-in-she-file-score-display-main-main-container'>
                    <h4>SHE File :<span className='secondary-color-paragraph'> {selectedShePackName}</span></h4>

                    <div className='consultant-fill-in-she-file-score-display-main-container'>

                      <div>
                        <p><span className='secondary-color-paragraph'>Score</span></p>
                      </div>
                      <div>
                        {totalUserScore} / {shePackScore}
                      </div>
                    </div>

                    <div>
                      <p><span className='secondary-color-paragraph'>Percentage : {totalUserPercentage || 0} %</span></p>
                    </div>
                  </div>
              </div>
            </div>

            
            
            {isLoading ? (
              <div className="loading-spinner-container">
                <LiaSpinnerSolid className="lia-spin-solid-icon" />
              </div>
            ) : (
              <div className='compliance-tracker-consultant-fill-in-table-main-container'>
                <div className="compliance-tracker-consultant-fill-in-table-container">

                  <table className='compliance-tracker-consultant-fill-in-table'>

                    <colgroup>

                      <col style={{width: "50px"}}/>{/* view */}
                      <col style={{width: "350px"}}/>{/* template name */}
                      <col style={{width: "150px"}}/>{/* Template score */}
                      <col style={{width: "100px"}}/>{/* Template % */}
                      <col style={{width: "150px"}}/>{/* Submission Status */}
                      <col style={{width: "150px"}}/>{/* QA Status */}
                                            
                    </colgroup>

                    <thead>
                      <tr>
                        <th>View Questions</th>
                        <th>Template Name</th>
                        <th>Template Score</th>
                        <th>Template %</th>
                        <th>Status</th>
                        <th>Download Template Report</th>

                      </tr>
                    </thead>

                    <tbody>

                      {shePackDocuments.length === 0 ? (
                        <tr>
                          <td>
                            <i>No documents found for this SHE Pack.</i>
                          </td>
                        </tr>
                      ) : (
                        shePackDocuments.map((document, index) => (
                          
                          <>

                          <tr key={index}>
                            
                              <td>
                                <FaClipboardList 
                                  className='view-checklist-submition-icon' 
                                  onClick={() => toggleDocument(document.shepack_document_id)}
                                />
                              </td>
                              <td>{document.shepack_document_name}</td>
                              
                              <td>
                                {document.user_score === 0 && document.updated_she_pack_document_score === 0 && document.submission_status !== 'Not Started' &&
                                (parseFloat(document.user_percentage) === 0)
                                  ? 'Not Applicable'
                                  : `${document.user_score} / ${document.updated_she_pack_document_score}`
                                }
                              </td>

                              <td>
                                
                                {document.user_score === 0 && document.updated_she_pack_document_score === 0 && document.submission_status !== 'Not Started' &&
                                (parseFloat(document.user_percentage) === 0)
                                  ? 'Not Applicable'
                                  : `${document.user_percentage} %`
                                } 
                              </td>

                              <td>{document.submission_status || 'No submission'}</td>
                              <td>
                                <FaFileDownload 
                                  className='view-checklist-submition-icon'
                                  onClick={() => handleTemplateDownloadReport(document)}
                                  style={{ cursor: 'pointer' }}
                                />
                              </td>

                              </tr>

                              
                         
                            
                            {expandedDocuments[document.shepack_document_id] && (
                              <tr>
                                <td colSpan="6">

                                  <div className='template-questions-fill-in-main-container'>

                                    {questionsPerDocument[document.shepack_document_id] && 
                                  Object.entries(questionsPerDocument[document.shepack_document_id]).map(([category, categoryQuestions]) => (
                                    <div className='template-questions-fill-in-container' key={category}>

                                     {/*<h2>
                                                            {category === " " && (

                                                                <div>
                                                                    Category - <span className='secondary-color-paragraph'>{category}</span>
                                                                </div>

                                                              )}
                                                          </h2> */}
                                      <div className="checklist-question-toaster-user-fill-in-checklist-category-container">
                                      
                                        <div className="compliance-tracker-consultant-fill-in-table-main-container">
                                          <div className='compliance-tracker-consultant-fill-in-table-container'>
                                            <table className="compliance-tracker-consultant-fill-in-table">
                                              <colgroup>
                                                <col style={{ width: "350px" }} />
                                                <col style={{ width: "200px" }} />
                                                <col style={{ width: "250px" }} />
                                                <col style={{ width: "200px" }} />
                                                <col style={{ width: "200px" }} />
                                              </colgroup>
                                              <thead>
                                                <tr>
                                                  <th>Question Name</th>
                                                  <th>Question Reference</th>
                                                  <th>Score</th>
                                                  <th>Comment</th>
                                                  <th>View</th>
                                                </tr>
                                              </thead>
                                              <tbody>
                                                {categoryQuestions.map((question, index) => (
                                                  <tr key={index}>
                                                    <td
                                                      style={{
                                                      maxWidth: "300px",
                                                      wordWrap: "break-word",
                                                      whiteSpace: "normal"
                                                  }}>
                                                    {question.question_name}</td>
                                                    <td className="secondary-color-text">{question.question_reference}</td>
                                                    <td>
                                                      <div className="score-container">
                                                        <p>
                                                          {question.user_question_score === 'Not Applicable'
                                                            ? 'Not Applicable'
                                                            : `${question.user_question_score || 'Score Not Selected'} / ${question.question_score}`
                                                          }
                                                        </p>


                                                      </div>
                                                    </td>
                                                    <td
                                                      style={{
                                                      maxWidth: "300px",
                                                      wordWrap: "break-word",
                                                      whiteSpace: "normal"
                                                  }}>
                                                    
                                                      <div className="additional-info-container">
                                                        <p className="comment-text">
                                                          {question.user_comment || 'No additional comments provided.'}
                                                        </p>
                                                      </div>
                                                    </td>
                                                    <td>
                                                      <div>
                                                        <CiImageOn 
                                                          className='view-checklist-submition-icon' 
                                                          onClick={() => openFullScreenImage(question)} 
                                                        />
                                                        {question.user_response
                                                          ? question.user_response.length > 15
                                                            ? `${question.user_response.substring(0, 15)}...`
                                                            : question.user_response
                                                          : ''}

                                                      </div>
                                                    </td>
                                                  </tr>
                                                ))}
                                              </tbody>
                                            
                                            </table>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  ))
                                }

                                  </div>

                                </td>
                                
                              </tr>
                            )}
                        
                          
                          </>
                        ))
                      )}

                    </tbody>

                  </table>
                  
                 
                    
                
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      
      {/* Full Screen Image Modal */}
      {(fullScreenImage || imageError) && (
        <div 
          className="full-screen-image-overlay" 
          onClick={closeFullScreenImage}
        >
          <div className="full-screen-image-container">
            {fullScreenImage ? (
              <img 
                src={fullScreenImage} 
                alt="Full Screen Preview" 
                className="full-screen-image"
                onClick={(e) => e.stopPropagation()} 
              />
            ) : (
              <div className="image-error-message">
                {imageError}
              </div>
            )}
            <button 
              className="close-image-modal-btn" 
              onClick={closeFullScreenImage}
            >
              &times;
            </button>
          </div>
        </div>
      )}
      
      {showToaster.questionSaved && <ItemAddedToaster item={'Question Saved'} />}
      {showToaster.categorySaved && <ItemAddedToaster item={'Category Saved'} />}
      {showSuccess && <CreatedSuccesFullyToaster heading='SHE File Filled Successfully' />}
    </div>
  );
};

export default ToasterViewSubmissionComponent;